import { render, staticRenderFns } from "./AdminListCompanies.vue?vue&type=template&id=95a2c03e"
import script from "./AdminListCompanies.vue?vue&type=script&lang=js"
export * from "./AdminListCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports